/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 7/7/13
 * Time: 1:03 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Notifier = require('ui/notifier/Notifier');
    var CONST = require("const");
    var Translator = require("i18n/translator");
    var Backbone = require("backbone");

    var BaseRouterController = Marionette.Controller.extend({

        blockNavigation: function (options) {
            var notifier = new Notifier(CONST.MODULES.FRAMEWORK, CONST.APP_ROOT_CONTAINER, CONST.APP_ROOT_CONTAINER);
            var title = Translator.translate('LEFramework.blockNavigation.title');
            var message = Translator.translate('LEFramework.blockNavigation.message');
            var actionText = Translator.translate('LEFramework.blockNavigation.objectAction.message');
            if (options && options.blockTranslation) {
                title = options.blockTranslation.title || title;
                message = options.blockTranslation.message || message;
                actionText = options.blockTranslation.actionText || actionText;
            }
            notifier.showConfirm({
                title: title,
                content: message,
                "objectAction": {
                    text: actionText,
                    callback: options.callback
                }
            });
        },
        getActivePageName: function (fragment) {
            if (this.navigation && this.navigation.pageNamesByRoutes) {
                if (!this.navigation.pageNamesByRoutesRegExp) {
                    this.navigation.pageNamesByRoutesRegExp = this._getPageDataByRoutesRegExp(this.navigation.pageNamesByRoutes);
                }
                var matched = this._getMatchedRouteObj(this.navigation.pageNamesByRoutesRegExp, fragment);
                if (matched && matched.value) {
                    var pageName=matched.value;
                    if(pageName.indexOf("controller.")===0){
                        pageName = this.getPageName(pageName,matched.route ,fragment);
                    }

                    return pageName;
                }
            }
        },
        getPageName:function(funcStr,route, fragment){
            var pageName;
            var functionName = funcStr.slice(("controller.").length);
            if(this[functionName] && _.isFunction(this[functionName])){
                var args= Backbone.Router.prototype._extractParameters(route, fragment);
                pageName =this[functionName].apply(this, args);
            }
            return pageName;
        },

        isRouteHaveSpecialNavigate: function (fragment) {
            if (this.navigation && this.navigation.specialNavigateByRoutes) {
                if (!this.navigation.specialNavigateByRoutesRegExp) {
                    this.navigation.specialNavigateByRoutesRegExp = this._getPageDataByRoutesRegExp(this.navigation.specialNavigateByRoutes);
                }
                var matched = this._getMatchedRouteObj(this.navigation.specialNavigateByRoutesRegExp, fragment);
                if (matched) {
                    return matched.value;
                }
            }
        },

        _getPageDataByRoutesRegExp: function(baseObjByRoutes) {
            var regExpArr = [];
            _.each(baseObjByRoutes, function (value, key) {
                regExpArr.push({
                    route: Backbone.Router.prototype._routeToRegExp(key),
                    value: value
                });
            },this);

            return regExpArr;
        },

        _getMatchedRouteObj: function(regExpArr, fragment) {
            var matchedRoute = _.find(regExpArr, function (obj) {
                if (obj.route.test(fragment)) {
                    return true;
                }
            });
            return matchedRoute;
        }
    });

    return BaseRouterController;

});
